var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPump(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#004A77",
    stroke: "current",
    className: "st0",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4.37194e-08 15.0024C4.55949e-09 16.1069 0.895432 15.9997 2 15.9997L2 13.9997L10 13.9997C13.3137 13.9997 16 11.3135 16 7.99973C16 7.29856 15.8797 6.62522 15.6586 5.99973L18 5.99973L18 7.99973C19.1046 7.99973 20 8.10687 20 7.00238L20 1.00256C20 -0.10193 19.1046 -0.000269771 18 -0.000269723L18 1.99973L10 1.99973C6.68629 1.99973 4 4.68601 4 7.99973C4 8.70091 4.1203 9.37425 4.34141 9.99974L2 9.99974L2 7.99973C0.895431 7.99973 -3.54267e-07 7.89789 -3.05988e-07 9.00238L-4.37194e-08 15.0024ZM11.7143 7.99973C11.7143 7.05296 10.9468 6.28538 10 6.28538C9.05323 6.28538 8.28571 7.05296 8.28571 7.99973C8.28571 8.94651 9.05323 9.71409 10 9.71409C10.9468 9.71409 11.7143 8.94651 11.7143 7.99973Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPump);
export default __webpack_public_path__ + "static/media/Pump.c91279894f5130458f32bc1aca9eac99.svg";
export { ForwardRef as ReactComponent };